import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Status, type DependencyState } from '../../../../../../../shared/dependenciesV2';
import type Locator from '../../../../../../../shared/Locator';
import { getStatusFromDependencyState } from '../helpers';
import FailedStatePanel from './FailedStatePanel';
import BuildStatePanel from './BuildStatePanel';
import * as DependenciesV2Store from '../../../../../../redux/dependenciesV2';
import LoadingPanel from './LoadingPanel';
import UnknownStatePanel from './UnknownStatePanel';
import type { DependencyV2Modals } from '../../../hooks/useDependencyModals';

type Props = {
  revision: Locator;
  status: DependencyState;
  modals: DependencyV2Modals
};

const StateContextPanel: VoidFunctionComponent<Props> = ({
  revision,
  status,
  modals,
}) => {
  const revisionInstance = useSelector(DependenciesV2Store.selectors.getBuildWatchRevision(revision.toFullString()));
  const latestBuild = useSelector(DependenciesV2Store.selectors.getLatestBuildOnRevision(revision.toFullString()));
  const statusState = getStatusFromDependencyState(status);

  if (statusState === Status.Analyzed) {
    return null;
  }

  if (!revisionInstance && statusState !== Status.Unknown) {
    return <LoadingPanel />;
  }

  return (
    <>
      {statusState === Status.Failed
        && <FailedStatePanel error={status.error} />}
      {statusState === Status.InProgress
        && <BuildStatePanel buildId={latestBuild?.id} buildModal={modals.streamBuildModal} />}
      {statusState === Status.Unknown && <UnknownStatePanel revision={revision.toFullString()} />}
    </>
  );
};

export default StateContextPanel;
